import React from "react";

const ReactFormContext = React.createContext();
export default ReactFormContext;
